import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "panel"]

  toggle(event) {
    const type = event.params.type
    const targetPanel = this.panelTargets.find(p => p.dataset.alertesType === type)

    if (!targetPanel) return

    const wasVisible = !targetPanel.classList.contains("hidden")

    this.panelTargets.forEach(p => p.classList.add("hidden"))
    this.badgeTargets.forEach(b => b.classList.remove("ring-2", "ring-offset-1"))

    if (!wasVisible) {
      targetPanel.classList.remove("hidden")
      event.currentTarget.classList.add("ring-2", "ring-offset-1")
    }
  }

  close() {
    this.panelTargets.forEach(p => p.classList.add("hidden"))
    this.badgeTargets.forEach(b => b.classList.remove("ring-2", "ring-offset-1"))
  }
}
